/* ------------------------------------------------------------------------------
@name: SceneGlobal
@description: SceneGlobal
--------------------------------------------------------------------------------- */

// - SceneGlobal
const SceneGlobal = (() => {
  // init controller
  var controller = new ScrollMagic.Controller();

  const handleSceneGlobal = () => {
    $(window).on("load", function () {
      setTimeout(function () {
        $("body").removeClass("overflow-hidden");
        $("#preloader").fadeOut("slow"), $("main").addClass("loaded");
      }, 1500);
    }),
      // fadeIn
      $(".section__fadeInGlobal").each(function () {
        const ttl = new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: 0.5,
        })
          .setClassToggle(this, "fade-in")
          .addTo(controller);
      });

    // fadeOut
    $(".section__fadeOutGlobal").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setClassToggle(this, "fade-out")
        .addTo(controller);
    });

    // leftIn
    $(".section__leftIn").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setClassToggle(this, "left-in")
        .addTo(controller);
    });

    // rightIn
    $(".section__rightIn").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setClassToggle(this, "right-in")
        .addTo(controller);
    });

    // topIn
    $(".section__topIn").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setClassToggle(this, "top-in")
        .addTo(controller);
    });

    // bottomIn
    $(".section__bottomIn").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.7,
      })
        .setClassToggle(this, "bottom-in")
        .addTo(controller);
    });

    // img
    $(".section__img").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setClassToggle(this, "img-in")
        .addTo(controller);
    });
  };

  // - init
  const init = () => {
    handleSceneGlobal();
  };

  // return
  return {
    init,
  };
})();

export default SceneGlobal;
